export default {
    contentBlock: {
        activity: {
            options: [
                { key: 1, value: 'Recently Created', field: 'created', op: 'gte' },
                { key: 2, value: 'Recently Updated', field: 'modified', op: 'gte' },
                { key: 3, value: 'Recently Shared' },
                { key: 4, value: 'Archived', field: 'archived', fieldValue: true }
            ]
        },
        sort: {
            options: [
                { key: '1', value: 'Created', header: true },
                { key: '1-1', value: 'Most Recent Created', field: 'created', direction: -1 },
                { key: '1-2', value: 'Least Recent Created', field: 'created', direction: 1 },
                { key: '2', value: 'Updated', header: true },
                { key: '2-1', value: 'Most Recent Updated', field: 'modified', direction: -1  },
                { key: '2-2', value: 'Least Recent Updated', field: 'modified', direction: 1  },
                { key: '3', value: 'Alphabetical', header: true },
                { key: '3-1', value: 'Alphabetical: A to Z', field: 'name', direction: 1  },
                { key: '3-2', value: 'Alphabetical: Z to A', field: 'name', direction: -1  }
            ]
        },
        channel: {
            label: 'Channel',
            options: [
                { key: '1', value: 'Email' },
                { key: '2', value: 'Direct Mail' },
                { key: '3', value: 'Facebook' }
            ],
            type: 'singleSelect',
            validation: {
                required: true
            }
        },
        description: {
            characterLimit: 250,
            label: 'Template Description',
            type: 'multilineString'
        },
        expiration: {
            label: 'Expiration',
            description: 'Objects set to expire will be automatically archived.',
            type: 'date',
            dropup: true
        },
        language: {
            label: 'Language',
            options: [
                { key: 'EN-US', value: 'English (US)' },
                { key: 'ES-MX', value: 'Spanish (MX)' },
                { key: 'FR-CA', value: 'French (CA)' },
            ],
            type: 'singleSelect',
            validation: {
                required: true
            }
        },
        licensing: {
            label: 'Licensing',
            description: 'Customize the way users are allowed to access templates.',
            options: [
                { key: 'copy', value: 'Okay to Copy' }
            ],
            type: 'checkGroup'
        },
        marketingCategory: {
            label: 'Marketing Category',
            options: [
                { key: '1', value: 'Aquisition' },
                { key: '2', value: 'Transaction' },
                { key: '3', value: 'Retention' },
                { key: '4', value: 'Milestone' },
                { key: '5', value: 'Winback' },
            ],
            type: 'radioGroup',
            validation: {
                required: true
            }
        },
        name: {
            label: 'Template Name',
            type: 'string',
            validation: {
                required: true
            }
        }
    }
}
    


// WEBPACK FOOTER //
// src/pages/content-block-page/metadata.js